'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.toQueryString = exports.getQueryString = exports.getParams = exports.getBase = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBase = exports.getBase = function getBase(url) {
    if (!url) {
        return '';
    }
    if (url.includes('#')) {
        return url.substring(0, url.indexOf('#'));
    }
    if (url.includes('?')) {
        return url.substring(0, url.indexOf('?'));
    }
    return url;
};

// From https://stackoverflow.com/a/3855394/148256
var getParams = exports.getParams = function getParams(query) {
    if (!query) {
        return {};
    }

    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
        var _param$split = param.split('='),
            _param$split2 = (0, _slicedToArray3.default)(_param$split, 2),
            key = _param$split2[0],
            value = _param$split2[1];

        if (key) params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
        return params;
    }, {});
};

var getQueryString = exports.getQueryString = function getQueryString(url) {
    var base = getBase(url);
    var query = url.substring(base.length);
    if (query !== '' && query !== '/') {
        return query;
    }
    return '';
};

// https://stackoverflow.com/a/1714899/148256
var toQueryString = exports.toQueryString = function toQueryString(obj) {
    var arr = [];
    for (var p in obj) {
        // eslint-disable-next-line no-prototype-builtins
        if (obj.hasOwnProperty(p)) {
            arr.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    }
    arr.sort();
    return arr.join('&');
};


//////////////////
// WEBPACK FOOTER
// ./src/utils/url.js
// module id = ArKR
// module chunks = 46